var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToArrow(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9725 1.68419C17.4573 1.19952 18.1148 0.927246 18.8003 0.927246C19.4858 0.927246 20.1433 1.19952 20.6281 1.68419L30.9693 12.0254C31.454 12.5102 31.7262 13.1677 31.7262 13.8532C31.7262 14.5387 31.454 15.1962 30.9693 15.681L20.6281 26.0222C20.1405 26.4931 19.4875 26.7537 18.8096 26.7478C18.1318 26.7419 17.4833 26.47 17.004 25.9907C16.5247 25.5114 16.2528 24.8629 16.2469 24.1851C16.241 23.5072 16.5016 22.8542 16.9725 22.3666L22.9006 16.4385H3.28851C2.60285 16.4385 1.94527 16.1661 1.46043 15.6813C0.975592 15.1964 0.703213 14.5389 0.703213 13.8532C0.703213 13.1675 0.975592 12.5099 1.46043 12.0251C1.94527 11.5403 2.60285 11.2679 3.28851 11.2679H22.9006L16.9725 5.3398C16.4878 4.85498 16.2156 4.19752 16.2156 3.51199C16.2156 2.82646 16.4878 2.169 16.9725 1.68419Z",
    fill: "#9AA5B5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToArrow);
export default __webpack_public_path__ + "static/media/ToArrow.fcdbc5f2e7ef6aab8ba75be69604e383.svg";
export { ForwardRef as ReactComponent };